export default __webpack_public_path__ + "static/elisha-cf41b4d39ee087e863808f66a531b7fe.jpg";